import gql from 'graphql-tag';

export default gql`
    query GetUsersCheckEmail($input: CheckEmailInput) {
        getUsersCheckEmail(input: $input) {
            emailExists
        }
    }
`;
